var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tag",staticClass:"tag",class:{ active: _vm.active },on:{"click":_vm.handleTag}},[_vm._v("\n  "+_vm._s(_vm.tag.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }